import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { bl_fi_generic_doc_hdr_RowClass, PrintableFormatContainerModel, BranchDefaultPrintableFormatHdrService, DocumentShortCodesClass } from 'blg-akaun-ts-lib';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { AppConfig } from '../../visa';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { PrintService } from '../../services/print-service';
import { ToastrService } from "ngx-toastr";
import {
  catchError,
  tap} from "rxjs/operators";
import { DocTypeHandlers } from '../../models/doc-type-handler';


@Component({
  selector: 'app-util-cash-document-view-export',
  templateUrl: './cash-document-view-export.component.html',
  styleUrls: ['./cash-document-view-export.component.scss']
})
export class CashDocumentViewExportComponent implements OnInit {
  @Input() cashDoc$: Observable<any>;
  protected subs = new SubSink();

  @Input() draft$: Observable<bl_fi_generic_doc_hdr_RowClass>;
  @Output() print = new EventEmitter();

  readonly appletSettings$ = this.sessionStore.select(SessionSelectors.selectMasterSettings);

  apiVisa = AppConfig.apiVisa;
  printableFormat = new FormControl();
  cashDoc;
  txn_type;

  constructor(
    private toastr: ToastrService,
    private printService: PrintService,
    private branchPrintableService: BranchDefaultPrintableFormatHdrService,
    private readonly sessionStore: Store<SessionStates>
  ) {}

  ngOnInit() {
    this.subs.sink = this.cashDoc$.subscribe(resolve=>{
      this.cashDoc = resolve?.bl_fi_cash_document_hdr;
      this.txn_type = resolve?.bl_fi_cash_document_hdr?.server_doc_type;
    });
    this.subs.sink = this.sessionStore.select(SessionSelectors.selectMasterSettings).subscribe(master=>{
      if(master?.PRINTABLE_CASH_TRANSFER){
        this.printableFormat.setValue(master?.PRINTABLE_CASH_TRANSFER);
      }
    })
  }

  onPrintableFormatChange(e: PrintableFormatContainerModel) {
    this.printableFormat.setValue(e.bl_prt_printable_format_hdr.guid.toString());
  };

  onPrint() {
    let docShortCode = DocumentShortCodesClass.serverDocTypeToShortCodeMapper(this.cashDoc.server_doc_type?.toString());
    const docURL = DocTypeHandlers.getDocURL(this.txn_type);

    this.printService.batchPrintCashDocument(
      [this.cashDoc.guid],
      this.printableFormat.value,
      AppConfig.apiVisa
    ).pipe(
      tap((a) => {
        const downloadURL = window.URL.createObjectURL(a);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = `${docShortCode}-${this.cashDoc.stmt_no}.pdf`;
        link.click();
        link.remove();
        this.toastr.success(
          "Document Exported Successfully",
          "Success",
          {
            tapToDismiss: true,
            progressBar: true,
            timeOut: 2000,
          }
        );
      }),
      catchError((err) => {
        throw err;
      })
    ).subscribe({
      error: (err) => console.error("Error while printing:", err),
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}
